import { useGetClusterAdminInfo } from '../../api/admin';

const useCallerIsAdmin = () => {
  const clusterAdminInfoState = useGetClusterAdminInfo();

  return { clusterAdminInfoState };
};

export default useCallerIsAdmin;
